/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, February 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../../../../components/Button';
import backImg from '../../../../assets/images/Fireboard/back_arrow_white.png';
import NotificationBell from '../NotificationBell';
import strings from '../../../../globalization';
import classes from './Header.module.css';

const Header = ({
  goBack,
  showBack,
  onChangeSortBy,
  sortByName,
  onChangeSorting,
  ascending,
  showNotifications,
  setNotifications,
  notificationControlEnabled,
  snoozeEnabled,
  snoozeNotifications,
  notificationCount,
  totalNotificationsCount,
}) => {

  return (
    <div className={classes.container}>
      {showBack && (
        <Button className={classes.button} onClick={goBack}>
          <img src={backImg} className={classes.backImg} alt='back' />
          <span className={classes.buttonText}>{strings.goToFireboard}</span>
        </Button>
      )}
      <span className={classes.onedine}>{strings.onedineLable}</span>

      <div className={classes.switchContainer}>
        <span className={classes.sortByTimeTxt}>{strings.sortByName}</span>
        <div className={classes.toggleContainer} onClick={onChangeSortBy}>
          <div className={classNames({ [classes.dialogButton]: true, [classes.disabled]: sortByName })} />
        </div>
        <span className={classes.sortByTimeTxt}>{strings.sortByTime}</span>
      </div>

      <div className={classes.switchContainer}>
        <span className={classes.sortByTimeTxt}>{strings.ascCaps}</span>
        <div className={classes.toggleContainer} onClick={onChangeSorting}>
          <div className={classNames({ [classes.dialogButton]: true, [classes.disabled]: ascending })} />
        </div>
        <span className={classes.sortByTimeTxt}>{strings.descCaps}</span>
      </div>

      <NotificationBell
        showNotifications={showNotifications}
        setNotifications={setNotifications}
        notificationControlEnabled={notificationControlEnabled}
        snoozeEnabled={snoozeEnabled}
        snoozeNotifications={snoozeNotifications}
        notificationCount={notificationCount}
        totalNotificationsCount={totalNotificationsCount}
      />
    </div>
  )
};

export default Header;

Header.propTypes = {
  goBack: PropTypes.func,
  showBack: PropTypes.bool,
  onChangeSortBy: PropTypes.func,
  sortByName: PropTypes.bool,
  onChangeSorting: PropTypes.func,
  ascending: PropTypes.bool,
  showNotifications: PropTypes.bool,
  notificationCount: PropTypes.number,
  notificationControlEnabled: PropTypes.bool,
  snoozeEnabled: PropTypes.bool,
  snoozeNotifications: PropTypes.func,
  totalNotificationsCount: PropTypes.number,
  setNotifications: PropTypes.func,
};

Header.defaultProps = {
  goBack: () => { },
  showBack: false,
  onChangeSortBy: () => { },
  sortByName: true,
  onChangeSorting: () => { },
  ascending: true,
  showNotifications: false,
  notificationCount: 0,
  notificationControlEnabled: false,
  snoozeEnabled: false,
  snoozeNotifications: () => { },
  totalNotificationsCount: 0,
  setNotifications: () => { },
};
